import FilterComponent from './filterComponent'
import React, { useEffect, useState } from 'react';
import '../../css/filtersList.css'

const FiltersList = ({ listFilters, onSelectedChange, clear }) => {
  const [selectedValues, setSelectedValues] = useState({});

  const handleFilterChange = (filter, selectedItems) => {
    setSelectedValues(prev => ({
      ...prev,
      [filter.filterId]: selectedItems
    }));
  };

  useEffect(() => {
    onSelectedChange(selectedValues);
  }, [selectedValues]);

  return (
    <div className ="filters gap-2 flex flex-wrap">
      {listFilters.map((filter)=>(
        <FilterComponent 
          key={filter.filterId}
          filter= {filter}
          multipleAllowedBool= {filter.multipleAllowedBool}
          searchableBool= {filter.searchableBool} 
          onSelect = {handleFilterChange}
          clear={clear}
        />
      ))}
    </div>
  );
};

export default FiltersList;
